module.exports = __webpack_public_path__ + "static/media/temp-sanitizer.263b2dfe.png";